import { render, staticRenderFns } from "./SubGoalSettingsPopoutApp.vue?vue&type=template&id=7b2e0baf"
import script from "./SubGoalSettingsPopoutApp.vue?vue&type=script&lang=js"
export * from "./SubGoalSettingsPopoutApp.vue?vue&type=script&lang=js"
import style0 from "./SubGoalSettingsPopoutApp.vue?vue&type=style&index=0&id=7b2e0baf&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports